<template>
  <div class="banner">
    <!-- <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in img" :key="index">
        <img :src="image" />
      </van-swipe-item>
    </van-swipe> -->
    <mt-swipe :auto="4000">
      <mt-swipe-item v-for="(image, index) in img" :key="index">
        <img :src="image" alt=""/>
      </mt-swipe-item>
    </mt-swipe>
  </div>
</template>

<script>
import {Swipe, SwipeItem} from 'mint-ui'
import 'mint-ui/lib/swipe/style.css'
export default {
  components:{
    'mt-swipe':Swipe,
    'mt-swipe-item':SwipeItem,
  },
  data(){
    return{
      img:[
        "http://www.cippe.com.cn/miniprogram/banner01.jpg",
        "http://www.cippe.com.cn/miniprogram/banner02.jpg",
        "http://www.cippe.com.cn/miniprogram/banner03.jpg",
        "http://www.cippe.com.cn/miniprogram/banner04.jpg"
      ]
    }
  },
  mounted() {
    sessionStorage.setItem('selected','/home')
  },
};
</script>

<style scoped>
.banner img {
  height: auto;
  width: 100%;
}
.banner {
  margin-left: -10px;
  margin-right: -10px;
  overflow: hidden;
  height: 150px;
}
</style>